import {
  StockInformationSearchParams,
} from './types';

const rootDomain = process.env.GATSBY_EXTERNAL_DATA_API_URL;

const buildEndpointMap = (root: string) => ({
  rootDomain: root,
  endpoint: {
    stockInformation: `${root}/stock-information`,
  },
});

export const ExternalDataService = {
  ...buildEndpointMap(rootDomain),
  async get(endpoint: RequestInfo, params?: RequestInit): Promise<unknown> {
    const apiResponse = await fetch(endpoint, params)
      .then((response) => response.json())
    // eslint-disable-next-line no-console
      .catch((error) => console.error(error));
    return apiResponse || {};
  },
  buildSearchParams(params: Record<string, unknown>): string {
    return Object.entries(params)
      .flatMap((array) => `${array[0]}=${array[1]}`)
      .join('&');
  },
  async getStockInformation(params: StockInformationSearchParams): Promise<unknown> {
    return this.get(`${this.endpoint.stockInformation}?${this.buildSearchParams(params)}`);
  },
};
